export default __webpack_public_path__ + "static/media/photo--sm--misc-14.d934fb2d.jpg";